import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const moreTestimonials = [{
  initials: 'MF',
  quote: 'El Protocolo de 3 Minutos antes de cada toma difícil cambió la bajada de leche. Nadie me había explicado la conexión entre el estrés y la oxitocina.',
  name: 'Malena F.',
  city: 'Mendoza'
}, {
  initials: 'JP',
  quote: "Los 35 mitos del Bono 4 me hicieron llorar. El de 'pecho blando sin leche' lo tenía completamente instalado.",
  name: 'Jimena P.',
  city: 'La Plata'
}, {
  initials: 'SR',
  quote: 'Mamá Bajo Control me devolvió la semana. Recuperé 3 horas reales.',
  name: 'Sofía R.',
  city: 'Tucumán'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-282">
      <div className="max-w-6xl mx-auto" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-284">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light" data-id="element-285">
            ❤️ MÁS MAMÁS QUE YA LO TIENEN
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-286">
          {moreTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-darker p-8 rounded-2xl border border-brand-primary/20 shadow-xl" data-id="element-287">
              <div className="flex items-center gap-4 mb-6" data-id="element-288">
                <div className="w-14 h-14 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-accent font-bold text-xl" data-id="element-289">
                  {t.initials}
                </div>
                <div className="flex gap-1" data-id="element-290">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-291" />)}
                </div>
              </div>
              <p className="text-brand-cream text-lg italic mb-6 leading-relaxed" data-id="element-292">
                "{t.quote}"
              </p>
              <div className="text-brand-primary" data-id="element-293">
                <span className="font-bold text-brand-cream-light" data-id="element-294">
                  — {t.name}
                </span>
                , {t.city}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}